import React, { useState, useEffect } from 'react';
import { Switch, Typography } from '@mui/material';
import { motion } from 'framer-motion';

function CustomSwitch({ name, onChange, label, initialValue, uncheckedLabel, checkedLabel }) {
  const [value, setValue] = useState(initialValue ?? true);

  useEffect(() => {
    setValue(initialValue ?? true);
  }, [initialValue]);

  const handleChange = (event) => {
    const newValue = event?.target?.checked ?? event;
    setValue(newValue);
    onChange?.(name, newValue);
  };

  const hasOptionLabels = Boolean(uncheckedLabel || checkedLabel);

  return (
    <motion.div
      whileHover={{ scale: 1.02 }}
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 6,
        background: 'rgba(255,255,255,0.8)',
        borderRadius: 999,
        padding: '4px 10px',
        border: '1px solid rgba(0,0,0,0.07)',
        boxShadow: '0 1px 2px rgba(0,0,0,0.06)',
        backdropFilter: 'blur(4px)',
      }}
    >
      {label && (
        <Typography
          variant="caption"
          sx={{ color: 'text.secondary', fontWeight: 500 }}
        >
          {label}
        </Typography>
      )}

      {hasOptionLabels && (
        <Typography
          variant="caption"
          sx={{
            color: !value ? 'primary.main' : 'text.secondary',
            fontWeight: !value ? 700 : 500,
          }}
        >
          {uncheckedLabel}
        </Typography>
      )}

      <Switch
        checked={value}
        onChange={handleChange}
        name={name}
        size="small"
        sx={{
          '& .MuiSwitch-switchBase': {
            color: '#b91c1c',
          },
          '& .MuiSwitch-switchBase + .MuiSwitch-track': {
            backgroundColor: '#fca5a5',
            opacity: 0.6,
          },

          '& .MuiSwitch-switchBase.Mui-checked': {
            color: '#15803d !important',
          },
          '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
            backgroundColor: '#86efac !important',
            opacity: 0.8,
          },

          '& .MuiSwitch-track': {
            borderRadius: 9999,
          },
        }}
      />

      {hasOptionLabels && (
        <Typography
          variant="caption"
          sx={{
            color: value ? 'primary.main' : 'text.secondary',
            fontWeight: value ? 700 : 500,
          }}
        >
          {checkedLabel}
        </Typography>
      )}
    </motion.div>
  );
}

export default CustomSwitch;
